import { PencilIcon, TrashIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";

import * as S from "./CommentMenuBottomSheet.style";

interface CommentMenuBottomSheetProps {
  commentType: "COMMENT" | "REPLY";
  onClickEdit: () => void;
  onClickDelete: () => void;
}

const CommentMenuBottomSheet = ({
  commentType,
  onClickEdit,
  onClickDelete,
}: CommentMenuBottomSheetProps) => {
  const commentTarget = commentType.toLowerCase();

  return (
    <S.BottomSheetContainer>
      <S.MenuList role="button" onClick={onClickEdit}>
        <PencilIcon strokeColor={grayScale.white} />
        <span>Edit {commentTarget}</span>
      </S.MenuList>
      <S.MenuList role="button" onClick={onClickDelete}>
        <TrashIcon strokeColor={grayScale.white} />
        <span>Delete {commentTarget}</span>
      </S.MenuList>
    </S.BottomSheetContainer>
  );
};

export default CommentMenuBottomSheet;
